import React from 'react';
import PropTypes from 'prop-types';
import ProviderButton from '../ProviderButton';
import style from './TopProviders.module.scss';

const TopProviders = ({ handleMVPDSelect, topProviders = [] }) => {
  if (!topProviders.length) return null;
  return (
    <>
      <div role="presentation" className={style.root}>
        {topProviders?.slice(0, 8).map(item => {
          const { logos, name, provider, id, adobePassId } = item;
          return (
            <ProviderButton
              handleMVPDSelect={() => handleMVPDSelect(adobePassId, name)}
              key={id}
              name={name}
              provider={provider}
              url={logos?.[1]?.url || ''}
            />
          );
        })}
      </div>
    </>
  );
};

export default TopProviders;

TopProviders.propTypes = {
  handleMVPDSelect: PropTypes.func,
  topProviders: PropTypes.shape([]),
};
